import { Easing } from 'react-native-reanimated';

export const IOS_EASING = Easing.bezier(0.36, 0.66, 0.04, 1);
export const ANDROID_EASING = Easing.bezier(0.4, 0, 0.2, 1);
